// Returns the user to the deep link they opened before the wallet sent them to
// unlock / onboarding (mobile-web).
//
// Pairs with KeystoreUnlockedRoute, which stashes the destination on its way to
// the unlock screen. The restore lives here, at the router level, rather than
// inside the unlock screen: onboarding ends in the same place, and a fresh user
// following a deep link goes through get-started, not unlock.
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { consumePendingDeepLink } from '@common/modules/router/helpers/pendingDeepLink'

const usePendingDeepLinkRestore = (isUnlocked: boolean, isAuthenticated: boolean) => {
  const navigate = useNavigate()
  // The stash is single-use, but the effect can re-run — this keeps us from
  // fighting a navigation the user made themselves after the restore.
  const restoredRef = useRef(false)

  useEffect(() => {
    if (restoredRef.current) return
    if (!isUnlocked || !isAuthenticated) return

    const target = consumePendingDeepLink()
    restoredRef.current = true
    if (!target) return

    // `replace` so Back does not bounce the user through the unlock screen.
    navigate(target, { replace: true })
  }, [isUnlocked, isAuthenticated, navigate])
}

export default usePendingDeepLinkRestore
